let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4PQXU"), load("5joXW"), load("1epse"), load("9IyPY")]).then(() => parcelRequire('1XrYH'));